import { render, staticRenderFns } from "./AutoList.vue?vue&type=template&id=0943aa08&scoped=true&"
import script from "./AutoList.vue?vue&type=script&lang=js&"
export * from "./AutoList.vue?vue&type=script&lang=js&"
import style0 from "./AutoList.vue?vue&type=style&index=0&id=0943aa08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0943aa08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VVirtualScroll})
